import errorHandler from '@/core/responsive/image/helpers/image-error-handler';

const onErrorDirective = {
    beforeMount(el: HTMLElement, binding) {
        const classNameModifier = binding.value ?? '';
        const classNamesArray = ['c-on-error', classNameModifier];
        el.addEventListener('error', () => errorHandler(el, classNamesArray));
    },
};

export default onErrorDirective;
